// Filtr příznaků v kategorii — sekce s nadpisem, přepínače „Na skladě“ a vybraných příznaků
const detectedFlagColors = {};
const FLAGS_FILTER_DESKTOP = "(min-width: 768px)";

function getFlagsFilterConfig() {
    return window.shopDataLayer ? window.shopDataLayer.flagsFilter : null;
}

// Barva příznaku z karet produktů na stránce (Shoptet ji vykresluje jako pozadí štítku)
function detectFlagColor(name) {
    if (detectedFlagColors[name]) {
        return detectedFlagColors[name];
    }

    $(".product .flag").each(function () {
        const color = $(this).css("background-color");

        if ($.trim($(this).text()) === name && color && color !== "transparent" && color !== "rgba(0, 0, 0, 0)") {
            detectedFlagColors[name] = color;
            return false;
        }
    });

    return detectedFlagColors[name] || "";
}

// Zobrazují se jen příznaky z visibleIds, ostatní se schovají
function isFlagVisible(config, id) {
    return (config.visibleIds || []).map(String).indexOf(id) > -1;
}

function initFlagsFilter() {
    const config = getFlagsFilterConfig();

    if (!config) {
        return;
    }

    $("#filters .filter-section-boolean").each(function () {
        const $section = $(this);
        let enabledCount = 0;
        let hasActive = false;

        // Sekce je po každém AJAX překreslení nová — zpracovaná se přeskočí
        if ($section.hasClass("myflags-ready")) {
            return;
        }

        $section.addClass("myflags-ready");

        // Sklad jako přepínač ve stejné sekci
        $section.find("input[data-filter-code='stock']").each(function () {
            const $input = $(this);

            $input.parent().addClass("myflags-item")[0].style.setProperty("--flag-color", config.stockColor || config.defaultColor);

            if (!$input.is(":disabled")) {
                enabledCount++;
            }

            if ($input.is(":checked")) {
                hasActive = true;
            }
        });

        $section.find("input[data-filter-code='dd']").each(function () {
            const $input = $(this);
            const $item = $input.parent();
            const $label = $input.next("label");
            const id = String($input.attr("data-filter-id"));
            const $nameNode = $label.contents().filter(function () {
                return this.nodeType === 3 && $.trim(this.nodeValue) !== "";
            }).first();
            const name = $.trim($nameNode.text());
            const flag = (config.flags && config.flags[id]) || {};

            $item.addClass("myflags-item");

            if (!isFlagVisible(config, id)) {
                $item.addClass("is-hidden");
                $label.removeClass("active");
                return;
            }

            if (!$input.is(":disabled")) {
                enabledCount++;
            }

            if (flag.name && $nameNode.length) {
                $nameNode[0].nodeValue = flag.name;
            }

            $item[0].style.setProperty("--flag-color", flag.color || detectFlagColor(name) || config.defaultColor);

            if ($input.is(":checked")) {
                hasActive = true;
            }
        });

        // Desktop = sekce rozbalená, mobil = sbalená, pokud v ní není nic zapnuté
        // (nezávisle na pořadí handlerů v main.js)
        $section.toggleClass("active", hasActive || window.matchMedia(FLAGS_FILTER_DESKTOP).matches);

        // Bez příznaku, který jde zapnout, se sekce nezobrazí (aktivní příznak ji drží vždy)
        if (!enabledCount && !hasActive) {
            return;
        }

        $section.addClass("myflags");
        $("<h4><span>" + config.title + "</span></h4>").prependTo($section);
    });
}

$(document).ready(function () {
    initFlagsFilter();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    initFlagsFilter();
});

document.addEventListener("ShoptetDOMPageContentLoaded", function () {
    initFlagsFilter();
});
